import { action, observable } from 'mobx';
import { requestQRCode } from 'services/base/ipc';
import { IAccountsDomain } from 'services/accounts/types';
import { ClaimPangolinKind, ClaimPangolinResult, claim } from 'services/accounts/pangolin_service';
import { BusyStore } from 'ui/base/button';

export class AddPangolinMethodStore {

  @observable.ref
  busy: BusyStore;

  constructor() {
    this.busy = new BusyStore();
  }

  @action.bound
  async handleQRCode(domain: IAccountsDomain): Promise<ClaimPangolinResult | undefined> {
    try {
      const code = await requestQRCode();
      return await claim({
        domain,
        kind: ClaimPangolinKind.NONCE,
        registrationNonce: code,
      });
    } catch (e) {
      // Do nothing
      return undefined;
    }
  }
}